import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Input } from '../../components/ui/Input';
import { Badge } from '../../components/ui/Badge';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../../components/ui/Select';
import { Modal } from '../../components/ui/Modal';
import { 
  Network, 
  Plus, 
  Edit, 
  Trash2, 
  Play, 
  Pause, 
  BarChart3,
  Filter,
  Search,
  ArrowUp,
  ArrowDown,
  Target,
  Clock,
  AlertTriangle,
  CheckCircle,
  Users,
  RefreshCw,
  Download,
  Upload,
  Settings,
  Zap,
  RotateCcw,
  Eye,
  EyeOff,
  Copy,
  ExternalLink,
  TrendingUp,
  TrendingDown,
  Star,
  Crown,
  Shield,
  Activity,
  UserCheck,
  Timer,
  Brain,
  Route,
  Lightning,
  Cpu,
  Database,
  Monitor,
  UserPlus,
  UserMinus,
  Calendar,
  Mail,
  Phone,
  Send,
  Archive,
  Unarchive,
  History,
  AlertCircle,
  Info,
  HelpCircle,
  XCircle,
  CheckCircle2,
  Clock3,
  CalendarDays,
  UserX,
  UserCog,
  UserSearch,
  UserEdit,
  Globe,
  Link,
  Key,
  Lock,
  Unlock,
  TestTube,
  Bug,
  Wifi,
  WifiOff,
  Server,
  Cloud,
  CloudOff,
  Terminal,
  Code,
  Hash,
  Layers,
  Box,
  Package,
  Archive as ArchiveIcon,
  File,
  Folder,
  FolderOpen,
  FileCode,
  FileJson,
  FileText as FileTextIcon,
  FileImage,
  FileVideo,
  FileAudio,
  FileSpreadsheet,
  FilePdf,
  FileZip,
  FileCheck,
  FileX,
  FilePlus,
  FileMinus,
  FileEdit,
  FileSearch,
  FileSlash,
  FileWarning,
  FileQuestion,
  FileHeart,
  FileClock,
  FileUp,
  FileDown,
  FileLeft,
  FileRight,
  FileBarChart,
  FilePieChart,
  FileLineChart,
  FileScissors,
  FileType,
  FileSymlink,
  FileStack,
  FileTree,
  FileBinary,
  FileCog,
  FileSettings,
  FileShield,
  FileLock,
  FileUnlock,
  FileKey,
  FileCertificate,
  FileSignature,
  FileVerified,
  FileBadge,
  FileTag,
  FileLabel,
  FileBookmark,
  FileStar,
  FileFlag,
  FileAlert,
  FileInfo,
  FileHelp,
  FileMessage,
  FileComment,
  FileChat,
  FileMail,
  FilePhone,
  FileVideo as FileVideoIcon,
  FileAudio as FileAudioIcon,
  FileImage as FileImageIcon,
  FileSpreadsheet as FileSpreadsheetIcon,
  FilePdf as FilePdfIcon,
  FileZip as FileZipIcon,
  FileCheck as FileCheckIcon,
  FileX as FileXIcon,
  FilePlus as FilePlusIcon,
  FileMinus as FileMinusIcon,
  FileEdit as FileEditIcon,
  FileSearch as FileSearchIcon,
  FileSlash as FileSlashIcon,
  FileWarning as FileWarningIcon,
  FileQuestion as FileQuestionIcon,
  FileHeart as FileHeartIcon,
  FileClock as FileClockIcon,
  FileUp as FileUpIcon,
  FileDown as FileDownIcon,
  FileLeft as FileLeftIcon,
  FileRight as FileRightIcon,
  FileBarChart as FileBarChartIcon,
  FilePieChart as FilePieChartIcon,
  FileLineChart as FileLineChartIcon,
  FileScissors as FileScissorsIcon,
  FileType as FileTypeIcon,
  FileSymlink as FileSymlinkIcon,
  FileStack as FileStackIcon,
  FileTree as FileTreeIcon,
  FileBinary as FileBinaryIcon,
  FileCog as FileCogIcon,
  FileSettings as FileSettingsIcon,
  FileShield as FileShieldIcon,
  FileLock as FileLockIcon,
  FileUnlock as FileUnlockIcon,
  FileKey as FileKeyIcon,
  FileCertificate as FileCertificateIcon,
  FileSignature as FileSignatureIcon,
  FileVerified as FileVerifiedIcon,
  FileBadge as FileBadgeIcon,
  FileTag as FileTagIcon,
  FileLabel as FileLabelIcon,
  FileBookmark as FileBookmarkIcon,
  FileStar as FileStarIcon,
  FileFlag as FileFlagIcon,
  FileAlert as FileAlertIcon,
  FileInfo as FileInfoIcon,
  FileHelp as FileHelpIcon,
  FileMessage as FileMessageIcon,
  FileComment as FileCommentIcon,
  FileChat as FileChatIcon,
  FileMail as FileMailIcon,
  FilePhone as FilePhoneIcon
} from 'lucide-react';
import { useDataContext } from '../../contexts/DataContext';

const mockIntegrationsData = [
  {
    id: 1,
    name: "Salesforce CRM",
    description: "Customer relationship management system integration",
    type: "CRM",
    status: "active",
    endpoint: "https://api.salesforce.com/v1",
    authentication: "OAuth 2.0",
    lastSync: "2025-01-15T16:30:00Z",
    nextSync: "2025-01-15T17:30:00Z",
    syncFrequency: "1 hour",
    recordsSynced: 1247,
    errors: 0,
    successRate: 100,
    createdAt: "2025-01-10T09:00:00Z",
    createdBy: "Sarah Johnson"
  },
  {
    id: 2,
    name: "Slack Workspace",
    description: "Team communication and notification integration",
    type: "Communication",
    status: "active",
    endpoint: "https://hooks.slack.com/services/...",
    authentication: "Webhook",
    lastSync: "2025-01-15T16:25:00Z",
    nextSync: "2025-01-15T17:25:00Z",
    syncFrequency: "1 hour",
    recordsSynced: 892,
    errors: 2,
    successRate: 99.8,
    createdAt: "2025-01-08T14:20:00Z",
    createdBy: "David Wilson"
  },
  {
    id: 3,
    name: "Jira Project Management",
    description: "Project and issue tracking integration",
    type: "Project Management",
    status: "syncing",
    endpoint: "https://company.atlassian.net/rest/api/3",
    authentication: "API Key",
    lastSync: "2025-01-15T16:15:00Z",
    nextSync: "2025-01-15T16:45:00Z",
    syncFrequency: "30 minutes",
    recordsSynced: 456,
    errors: 0,
    successRate: 100,
    createdAt: "2025-01-12T17:00:00Z",
    createdBy: "Mike Chen"
  },
  {
    id: 4,
    name: "Zendesk Support",
    description: "Customer support ticket integration",
    type: "Support",
    status: "error",
    endpoint: "https://company.zendesk.com/api/v2",
    authentication: "Basic Auth",
    lastSync: "2025-01-15T16:20:00Z",
    nextSync: "2025-01-15T16:50:00Z",
    syncFrequency: "30 minutes",
    recordsSynced: 234,
    errors: 12,
    successRate: 95.2,
    createdAt: "2025-01-13T08:30:00Z",
    createdBy: "Emma Davis"
  },
  {
    id: 5,
    name: "HubSpot Marketing",
    description: "Marketing automation and CRM integration",
    type: "Marketing",
    status: "inactive",
    endpoint: "https://api.hubapi.com/v3",
    authentication: "OAuth 2.0",
    lastSync: "2025-01-14T10:00:00Z",
    nextSync: null,
    syncFrequency: "2 hours",
    recordsSynced: 678,
    errors: 0,
    successRate: 100,
    createdAt: "2025-01-05T11:00:00Z",
    createdBy: "Lisa Thompson"
  }
];

const ExternalSystemIntegration = () => {
  const navigate = useNavigate();
  const { getMockData, updateMockData } = useDataContext();
  const [integrations, setIntegrations] = useState(mockIntegrationsData);
  const [logs, setLogs] = useState([]);
  const [syncStatus, setSyncStatus] = useState({});
  const [isCreatingIntegration, setIsCreatingIntegration] = useState(false);
  const [editingIntegration, setEditingIntegration] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterType, setFilterType] = useState('all');
  const [showMetricModal, setShowMetricModal] = useState(false);
  const [selectedMetric, setSelectedMetric] = useState(null);

  useEffect(() => {
    loadIntegrationData();
  }, []);

  const loadIntegrationData = async () => {
    try {
      const data = getMockData('externalSystems');
      const logsData = getMockData('integrationLogs');
      const syncData = getMockData('syncStatus');
      
      // Only update state if data exists, otherwise keep initial mock data
      if (data?.integrations && data.integrations.length > 0) {
        setIntegrations(data.integrations);
      }
      if (logsData?.logs) {
        setLogs(logsData.logs);
      }
      if (syncData) {
        setSyncStatus(syncData);
      }
    } catch (error) {
      console.error('Failed to load integration data:', error);
    }
  };

  const handleCreateIntegration = () => {
    navigate('/integration/settings');
  };

  const handleEditIntegration = (integration) => {
    navigate('/integration/settings');
  };

  const handleTestConnection = (integrationId) => {
    const integration = integrations.find(i => i.id === integrationId);
    alert(`Testing connection for "${integration.name}"...\n\n✓ Connection: Successful\n✓ Response Time: ${Math.floor(Math.random() * 200) + 50}ms\n✓ Endpoint: Reachable\n✓ Authentication: Valid\n\nTest completed successfully!`);
  };

  const handleSyncData = (integrationId) => {
    const integration = integrations.find(i => i.id === integrationId);
    if (window.confirm(`Are you sure you want to sync data for "${integration.name}"?`)) {
      alert(`Syncing data for "${integration.name}"...\n\n✓ Starting sync process\n✓ Fetching data from endpoint\n✓ Processing records\n✓ ${Math.floor(Math.random() * 100) + 50} records synced\n\nSync completed successfully!`);
    }
  };

  const handleDeleteIntegration = (integrationId) => {
    const integration = integrations.find(i => i.id === integrationId);
    if (window.confirm(`Are you sure you want to delete "${integration.name}"? This action cannot be undone.`)) {
      alert(`Integration "${integration.name}" deleted successfully!`);
    }
  };

  const handleToggleIntegration = (integrationId) => {
    const updatedIntegrations = integrations.map(integration => {
      if (integration.id === integrationId) {
        const newStatus = integration.status === 'active' ? 'inactive' : 'active';
        return { 
          ...integration, 
          status: newStatus
        };
      }
      return integration;
    });
    
    setIntegrations(updatedIntegrations);
    updateMockData('externalSystems', { integrations: updatedIntegrations });
    
    const updatedIntegration = updatedIntegrations.find(i => i.id === integrationId);
    alert(`Integration "${updatedIntegration.name}" ${updatedIntegration.status === 'active' ? 'enabled' : 'disabled'} successfully!`);
  };

  const handleSyncAll = () => {
    const activeIntegrations = integrations.filter(i => i.status === 'active');
    if (window.confirm(`This will sync all ${activeIntegrations.length} active integrations. Continue?`)) {
      alert(`Syncing all active integrations...\n\n${activeIntegrations.map(i => `✓ ${i.name}: Success`).join('\n')}\n\nAll syncs completed!`);
    }
  };

  const handleViewAnalytics = () => {
    navigate('/integration/analytics');
  };

  const handleIntegrationSettings = () => {
    navigate('/integration/settings');
  };

  const handleMetricClick = (metric) => {
    setSelectedMetric(metric);
    setShowMetricModal(true);
  };

  const handleTestAllConnections = () => {
    const activeIntegrations = integrations.filter(i => i.status === 'active');
    alert(`Testing all active integrations (${activeIntegrations.length})...\n\n${activeIntegrations.map(i => `✓ ${i.name}: Success`).join('\n')}\n\nAll tests completed!`);
  };

  const handleExportIntegrationData = () => {
    const integrationsData = integrations.map(integration => ({
      name: integration.name,
      type: integration.type,
      status: integration.status,
      successRate: integration.successRate,
      recordsSynced: integration.recordsSynced,
      lastSync: integration.lastSync
    }));
    
    const dataStr = JSON.stringify(integrationsData, null, 2);
    const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);
    const exportFileDefaultName = `integrations_export_${new Date().toISOString().split('T')[0]}.json`;
    
    const linkElement = document.createElement('a');
    linkElement.setAttribute('href', dataUri);
    linkElement.setAttribute('download', exportFileDefaultName);
    linkElement.click();
    
    alert('Integration data exported successfully!');
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'active': return 'green';
      case 'inactive': return 'gray';
      case 'error': return 'red';
      case 'syncing': return 'blue';
      case 'pending': return 'yellow';
      default: return 'gray';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'active': return CheckCircle;
      case 'inactive': return Pause;
      case 'error': return AlertTriangle;
      case 'syncing': return RefreshCw;
      case 'pending': return Clock;
      default: return AlertTriangle;
    }
  };

  const filteredIntegrations = integrations.filter(integration => {
    const matchesSearch = integration.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         integration.type.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         integration.description.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || integration.status === filterStatus;
    const matchesType = filterType === 'all' || integration.type === filterType;
    return matchesSearch && matchesStatus && matchesType;
  });

  const integrationMetrics = [
    {
      title: 'Total Integrations',
      value: integrations.length,
      icon: Network,
      bgColor: '#006600',
      textColor: '#FFFFFF',
      trend: '+1',
      trendDirection: 'up',
      details: [
        { label: 'CRM Systems', value: integrations.filter(i => i.type === 'CRM').length },
        { label: 'Communication', value: integrations.filter(i => i.type === 'Communication').length },
        { label: 'Project Management', value: integrations.filter(i => i.type === 'Project Management').length },
        { label: 'Support Systems', value: integrations.filter(i => i.type === 'Support').length },
        { label: 'Marketing Tools', value: integrations.filter(i => i.type === 'Marketing').length },
        { label: 'Total Records Synced', value: integrations.reduce((sum, i) => sum + i.recordsSynced, 0).toLocaleString() }
      ]
    },
    {
      title: 'Active Integrations',
      value: integrations.filter(i => i.status === 'active').length,
      icon: CheckCircle,
      bgColor: '#BB0000',
      textColor: '#FFFFFF',
      trend: '+1',
      trendDirection: 'up',
      details: [
        { label: 'Active Systems', value: integrations.filter(i => i.status === 'active').length },
        { label: 'Inactive Systems', value: integrations.filter(i => i.status === 'inactive').length },
        { label: 'Syncing Now', value: integrations.filter(i => i.status === 'syncing').length },
        { label: 'Error Status', value: integrations.filter(i => i.status === 'error').length },
        { label: 'Uptime', value: '99.8%' },
        { label: 'Avg Response Time', value: '125ms' }
      ]
    },
    {
      title: 'Success Rate',
      value: '98.7%',
      icon: Target,
      bgColor: '#006600',
      textColor: '#FFFFFF',
      trend: '+0.5%',
      trendDirection: 'up',
      details: [
        { label: 'Overall Success Rate', value: '98.7%' },
        { label: 'Successful Syncs (24h)', value: '1,247' },
        { label: 'Failed Syncs (24h)', value: '14' },
        { label: 'Average Sync Duration', value: '2.3s' },
        { label: 'Fastest Sync', value: '0.8s' },
        { label: 'Slowest Sync', value: '5.2s' }
      ]
    },
    {
      title: 'Failed Syncs',
      value: integrations.reduce((sum, i) => sum + i.errors, 0),
      icon: AlertTriangle,
      bgColor: '#BB0000',
      textColor: '#FFFFFF',
      trend: '-3',
      trendDirection: 'down',
      details: [
        { label: 'Total Errors Today', value: integrations.reduce((sum, i) => sum + i.errors, 0) },
        { label: 'Authentication Errors', value: '5' },
        { label: 'Network Timeouts', value: '6' },
        { label: 'Rate Limit Hits', value: '2' },
        { label: 'Invalid Data Errors', value: '1' },
        { label: 'Error Rate', value: '1.3%' }
      ]
    }
  ];

  const recentLogs = [
    {
      id: 1,
      integrationName: "Salesforce CRM",
      action: "sync_completed",
      status: "success",
      message: "Successfully synced 45 customer records",
      timestamp: "2025-01-15T16:30:00Z",
      duration: "2.3s"
    },
    {
      id: 2,
      integrationName: "Slack Workspace",
      action: "notification_sent",
      status: "success",
      message: "Sent notification to #support channel",
      timestamp: "2025-01-15T16:25:00Z",
      duration: "0.8s"
    },
    {
      id: 3,
      integrationName: "Zendesk Support",
      action: "sync_failed",
      status: "error",
      message: "Authentication failed - invalid credentials",
      timestamp: "2025-01-15T16:20:00Z",
      duration: "5.2s"
    }
  ];

  return (
    <div className="external-system-integration p-6 bg-gray-50 min-h-screen">
      {/* Header */}
      <div className="mb-6 bg-white rounded-lg shadow-sm p-6 border border-gray-100">
        <div className="flex justify-between items-center">
          <div>
            <h1 className="text-3xl font-bold text-gray-900">External System Integration</h1>
            <p className="text-gray-600 mt-1">Manage external system connections and data synchronization</p>
          </div>
          <div className="flex items-center space-x-3">
            <Button 
              onClick={handleCreateIntegration}
              className="transition-all duration-300 hover:scale-105 px-6 py-3"
              style={{ background: 'linear-gradient(135deg,#006600 0%,#BB0000 100%)' }}
            >
              <Plus className="h-4 w-4 mr-2" />
              Add Integration
            </Button>
            <Button 
              variant="outline" 
              onClick={handleViewAnalytics}
              className="transition-all duration-300 hover:scale-105 px-6 py-3"
              style={{ background: 'linear-gradient(135deg,#006600 0%,#BB0000 100%)' }}
            >
              <BarChart3 className="h-4 w-4 mr-2" />
              Analytics
            </Button>
          </div>
        </div>
      </div>

      {/* Metrics Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {integrationMetrics.map((metric, index) => {
          const Icon = metric.icon;
          const TrendIcon = metric.trendDirection === 'up' ? ArrowUp : ArrowDown;
          return (
            <Card 
              key={index} 
              className="hover:shadow-2xl transition-all duration-300 cursor-pointer transform hover:-translate-y-1 border-2"
              onClick={() => handleMetricClick(metric)}
              style={{ 
                backgroundColor: metric.bgColor,
                borderColor: metric.bgColor,
                color: metric.textColor
              }}
            >
              <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
                <CardTitle className="text-sm font-medium" style={{ color: metric.textColor }}>{metric.title}</CardTitle>
                <Icon className="h-5 w-5" style={{ color: metric.textColor }} />
              </CardHeader>
              <CardContent>
                <div className="text-3xl font-bold mb-2" style={{ color: metric.textColor }}>{metric.value}</div>
                <div 
                  className="flex items-center text-xs font-medium"
                  style={{ color: metric.textColor, opacity: 0.9 }}
                >
                  <TrendIcon className="h-3 w-3 mr-1" />
                  {metric.trend} from last week
                </div>
              </CardContent>
            </Card>
          );
        })}
      </div>

      {/* Recent Activity */}
      <Card className="mb-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Activity className="h-5 w-5 mr-2" />
            Recent Integration Activity
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {recentLogs.map((log) => (
              <div key={log.id} className="flex items-center justify-between p-3 border rounded-lg">
                <div className="flex items-center space-x-3">
                  <Badge variant={log.status === 'success' ? 'default' : 'destructive'}>
                    {log.status}
                  </Badge>
                  <div>
                    <div className="font-medium">{log.integrationName}</div>
                    <div className="text-sm text-gray-600">{log.message}</div>
                  </div>
                </div>
                <div className="text-right text-sm text-gray-600">
                  <div>{log.duration}</div>
                  <div>{new Date(log.timestamp).toLocaleString()}</div>
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>

      {/* Filters and Search */}
      <Card className="mb-8 shadow-md border-2" style={{ borderColor: '#f0f0f0' }}>
        <CardHeader className="bg-gradient-to-r from-gray-50 to-white">
          <CardTitle className="flex items-center text-gray-800">
            <Filter className="h-5 w-5 mr-2" style={{ color: '#307A91' }} />
            Filter Integrations
          </CardTitle>
        </CardHeader>
        <CardContent className="pt-6">
          <div className="flex items-center gap-4">
            <div className="flex-1 max-w-md">
              <div className="relative">
                <Search 
                  className="absolute left-3 top-1/2 transform -translate-y-1/2 h-5 w-5" 
                  style={{ color: '#307A91' }}
                />
                <Input
                  placeholder="Search integrations by name, type, or description..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="pl-11 pr-4 py-3 border-2 focus:ring-2 text-gray-800 placeholder-gray-500"
                  style={{ 
                    borderColor: '#e0e0e0',
                    focusRingColor: '#307A91'
                  }}
                />
              </div>
            </div>
            <Select value={filterStatus} onValueChange={setFilterStatus}>
              <SelectTrigger className="w-72 h-12 border-2 font-medium" style={{ borderColor: '#e0e0e0' }}>
                <SelectValue placeholder="All Status" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Status</SelectItem>
                <SelectItem value="active">Active</SelectItem>
                <SelectItem value="inactive">Inactive</SelectItem>
                <SelectItem value="syncing">Syncing</SelectItem>
                <SelectItem value="error">Error</SelectItem>
                <SelectItem value="pending">Pending</SelectItem>
              </SelectContent>
            </Select>
            <Select value={filterType} onValueChange={setFilterType}>
              <SelectTrigger className="w-72 h-12 border-2 font-medium" style={{ borderColor: '#e0e0e0' }}>
                <SelectValue placeholder="All Types" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">All Types</SelectItem>
                <SelectItem value="CRM">CRM</SelectItem>
                <SelectItem value="Communication">Communication</SelectItem>
                <SelectItem value="Project Management">Project Management</SelectItem>
                <SelectItem value="Support">Support</SelectItem>
                <SelectItem value="Marketing">Marketing</SelectItem>
              </SelectContent>
            </Select>
          </div>
        </CardContent>
      </Card>

      {/* Integrations List */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <Network className="h-5 w-5 mr-2" />
            External System Integrations ({integrations.length})
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-6">
            {integrations.map((integration) => {
              const StatusIcon = getStatusIcon(integration.status);
              return (
                <div key={integration.id} className="p-6 border rounded-lg hover:bg-gray-50 transition-colors">
                  <div className="flex items-start justify-between mb-4">
                    <div className="flex-1">
                      <div className="flex items-center space-x-3 mb-2">
                        <h3 className="text-lg font-semibold">{integration.name}</h3>
                        <Badge variant={integration.status === 'active' ? 'default' : 'secondary'}>
                          <StatusIcon className="h-3 w-3 mr-1" />
                          {integration.status}
                        </Badge>
                        <Badge variant="outline">{integration.type}</Badge>
                      </div>
                      <p className="text-gray-600 mb-3">{integration.description}</p>
                      
                      {/* Integration Details */}
                      <div className="mb-3">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Connection Details:</h4>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600">
                          <div>
                            <span className="font-medium">Endpoint:</span> {integration.endpoint}
                          </div>
                          <div>
                            <span className="font-medium">Auth:</span> {integration.authentication}
                          </div>
                          <div>
                            <span className="font-medium">Frequency:</span> {integration.syncFrequency}
                          </div>
                          <div>
                            <span className="font-medium">Records:</span> {integration.recordsSynced}
                          </div>
                        </div>
                      </div>

                      {/* Performance Metrics */}
                      <div className="mb-3">
                        <h4 className="text-sm font-medium text-gray-700 mb-2">Performance:</h4>
                        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 text-sm text-gray-600">
                          <div>
                            <span className="font-medium">Success Rate:</span> {integration.successRate}%
                          </div>
                          <div>
                            <span className="font-medium">Errors:</span> {integration.errors}
                          </div>
                          <div>
                            <span className="font-medium">Last Sync:</span> {integration.lastSync ? new Date(integration.lastSync).toLocaleString() : 'Never'}
                          </div>
                          <div>
                            <span className="font-medium">Next Sync:</span> {integration.nextSync ? new Date(integration.nextSync).toLocaleString() : 'Not scheduled'}
                          </div>
                        </div>
                      </div>

                      {/* Timestamps */}
                      <div className="flex items-center space-x-6 text-sm text-gray-600">
                        <div className="flex items-center">
                          <Calendar className="h-4 w-4 mr-1" />
                          <span>Created: {new Date(integration.createdAt).toLocaleString()}</span>
                        </div>
                        <div className="flex items-center">
                          <UserCheck className="h-4 w-4 mr-1" />
                          <span>Created By: {integration.createdBy}</span>
                        </div>
                      </div>
                    </div>

                    {/* Actions */}
                    <div className="flex items-center space-x-2 ml-4">
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleTestConnection(integration.id)}
                      >
                        <TestTube className="h-3 w-3 mr-1" />
                        Test
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleSyncData(integration.id)}
                      >
                        <RefreshCw className="h-3 w-3 mr-1" />
                        Sync
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleToggleIntegration(integration.id)}
                      >
                        {integration.status === 'active' ? (
                          <>
                            <Pause className="h-3 w-3 mr-1" />
                            Disable
                          </>
                        ) : (
                          <>
                            <Play className="h-3 w-3 mr-1" />
                            Enable
                          </>
                        )}
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleEditIntegration(integration)}
                      >
                        <Edit className="h-3 w-3 mr-1" />
                        Edit
                      </Button>
                      <Button
                        size="sm"
                        variant="outline"
                        onClick={() => handleDeleteIntegration(integration.id)}
                      >
                        <Trash2 className="h-3 w-3 mr-1" />
                        Delete
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </CardContent>
      </Card>

      {/* Quick Actions */}
      <Card className="mt-8">
        <CardHeader>
          <CardTitle className="flex items-center">
            <Zap className="h-5 w-5 mr-2" />
            Quick Actions
          </CardTitle>
        </CardHeader>
        <CardContent>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            <Button onClick={handleCreateIntegration} className="h-20 flex flex-col items-center justify-center space-y-2">
              <Plus className="h-6 w-6" />
              <span>Add Integration</span>
            </Button>
            <Button variant="outline" onClick={handleSyncAll} className="h-20 flex flex-col items-center justify-center space-y-2">
              <RefreshCw className="h-6 w-6" />
              <span>Sync All</span>
            </Button>
            <Button variant="outline" onClick={handleViewAnalytics} className="h-20 flex flex-col items-center justify-center space-y-2">
              <BarChart3 className="h-6 w-6" />
              <span>View Analytics</span>
            </Button>
            <Button variant="outline" onClick={handleIntegrationSettings} className="h-20 flex flex-col items-center justify-center space-y-2">
              <Settings className="h-6 w-6" />
              <span>Integration Settings</span>
            </Button>
          </div>
        </CardContent>
      </Card>

      {/* Metric Detail Modal */}
      {showMetricModal && selectedMetric && (
        <Modal
          isOpen={showMetricModal}
          onClose={() => setShowMetricModal(false)}
        >
          <div className="max-w-2xl -m-6">
            {/* Metric Header */}
            <div 
              className="px-8 py-6 rounded-t-lg text-white relative"
              style={{ 
                background: `linear-gradient(135deg, ${selectedMetric.bgColor} 0%, ${selectedMetric.bgColor}dd 100%)` 
              }}
            >
              <button
                onClick={() => setShowMetricModal(false)}
                className="absolute top-4 right-4 text-white/80 hover:text-white hover:bg-white/10 rounded-lg p-2 transition-all duration-200"
                aria-label="Close"
              >
                <XCircle className="h-6 w-6" />
              </button>
              <div className="flex items-center justify-between pr-12 mb-4">
                <h2 className="text-2xl font-bold">{selectedMetric.title}</h2>
                <selectedMetric.icon className="h-10 w-10" />
              </div>
              <div className="flex items-center justify-between">
                <div>
                  <p className="text-sm font-medium opacity-90 mb-1">Current Value</p>
                  <p className="text-4xl font-bold">{selectedMetric.value}</p>
                </div>
              </div>
              <div className="mt-4 flex items-center text-sm font-medium">
                {selectedMetric.trendDirection === 'up' ? (
                  <ArrowUp className="h-4 w-4 mr-1" />
                ) : (
                  <ArrowDown className="h-4 w-4 mr-1" />
                )}
                <span>{selectedMetric.trend} from last week</span>
              </div>
            </div>

            <div className="p-8 space-y-6">
              {/* Metric Details Grid */}
              <div className="grid grid-cols-2 gap-4">
              {selectedMetric.details.map((detail, index) => (
                <div 
                  key={index} 
                  className="p-4 bg-gray-50 rounded-lg border-2 hover:shadow-md transition-all"
                  style={{ borderColor: '#f0f0f0' }}
                >
                  <p className="text-sm text-gray-600 mb-1">{detail.label}</p>
                  <p className="text-2xl font-bold" style={{ color: selectedMetric.bgColor }}>
                    {detail.value}
                  </p>
                </div>
              ))}
            </div>

            {/* Action Buttons */}
            <div className="flex justify-end space-x-3 pt-4 border-t">
              <Button
                variant="outline"
                onClick={() => setShowMetricModal(false)}
                className="hover:bg-gray-100 transition-all"
                style={{
                  borderColor: selectedMetric.bgColor,
                  color: selectedMetric.bgColor
                }}
              >
                Close
              </Button>
              <Button
                onClick={() => {
                  setShowMetricModal(false);
                  handleViewAnalytics();
                }}
                className="transition-all hover:scale-105"
                style={{
                  background: `linear-gradient(135deg, ${selectedMetric.bgColor} 0%, ${selectedMetric.bgColor}dd 100%)`,
                  color: 'white',
                  border: 'none'
                }}
              >
                <BarChart3 className="h-4 w-4 mr-2" />
                View Analytics
              </Button>
              <Button
                onClick={() => {
                  setShowMetricModal(false);
                  handleTestAllConnections();
                }}
                className="transition-all hover:scale-105"
                style={{
                  background: 'linear-gradient(135deg, #348299 0%, #317D95 100%)',
                  color: 'white',
                  border: 'none'
                }}
              >
                <TestTube className="h-4 w-4 mr-2" />
                Test All
              </Button>
              <Button
                onClick={() => {
                  setShowMetricModal(false);
                  handleExportIntegrationData();
                }}
                className="transition-all hover:scale-105"
                style={{
                  background: 'linear-gradient(135deg, #FE7F50 0%, #FF7F4C 100%)',
                  color: 'white',
                  border: 'none'
                }}
              >
                <Download className="h-4 w-4 mr-2" />
                Export Data
              </Button>
            </div>
            </div>
          </div>
        </Modal>
      )}
    </div>
  );
};

export default ExternalSystemIntegration;
